import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { StaticUrls } from "../../AppRoutes";

function LocalStorageWatcher() {
  const location = useLocation();
  const prevPathRef = useRef(null); // previous path

  const isStaticPath = (path) => {
    if (!path) return true;
    if (path === "/") return true;
    return StaticUrls.some((url) => {
      const cleanUrl = url.replace(/:\w+/g, "").replace(/\*$/, "");
      return path.startsWith(cleanUrl);
    });
  };

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const currentPath = location.pathname;

    // Scenario 1: first load
    if (prevPath === null) {
      localStorage.setItem("fromPLPCategory_id", 0);
      localStorage.setItem("fromPLPCategory_url", "");
    }

    // // Scenario 2: previous and current path are different
    // if (prevPath !== null && prevPath !== currentPath) {
    //   localStorage.setItem("fromPLPCategory_id", 0);
    // }

    // Scenario 3: current path is a static path (including /)
    if (isStaticPath(currentPath)) {
      localStorage.setItem("fromPLPCategory_id", 0);
      localStorage.setItem("fromPLPCategory_url", "");
    }

    // update previous path
    prevPathRef.current = currentPath;
  }, [location.pathname]);

  return null;
}

export default LocalStorageWatcher;
